import {AccessRights} from "../constants";

export const PERMISSION_ICON_CLASS = {
    [AccessRights.MANAGE_USERS]: 'manageUsers',
    [AccessRights.SUBMIT_OTHER_USER_TIME_TRACK]: 'modifyTT',
    [AccessRights.EDIT_HIERARCHY]: 'manageScope',
    [AccessRights.GENERATE_MONEY_REPORTS]: 'costReports',
    [AccessRights.SUBMIT_TIME_TRACK]: 'submitTT',
    [AccessRights.LOCK_TIME_TRACK]: 'lockTT',
    [AccessRights.MANAGE_PTO_AND_SICK]: 'managePtoSick',
    [AccessRights.MANAGE_GENERAL_SETTINGS]: 'manageSettings',
}


// WEBPACK FOOTER //
// ./web/js/permissions/constants.js